import React from "react";
import { Flex, Icon, Text, Tooltip, useBoolean } from "@chakra-ui/react";
import { IoAlertCircle } from "react-icons/io5";

export interface AlertProps {
  label: string;
}

const Alert: React.FC<AlertProps> = ({ label }) => {
  const [isOpen, setIsOpen] = useBoolean(false);

  return (
    <Tooltip
      isOpen={isOpen}
      placement="right"
      label={<Text fontSize="lg">{label}</Text>}
    >
      <Flex>
        <Icon
          onMouseEnter={setIsOpen.toggle}
          onMouseLeave={setIsOpen.toggle}
          onTouchStart={setIsOpen.toggle}
          onTouchEnd={setIsOpen.toggle}
          color="red.500"
          as={IoAlertCircle}
          boxSize={5}
        />
      </Flex>
    </Tooltip>
  );
};

export default Alert;
